import RedeemPage from './RedeemPage';

export default RedeemPage;
